/**
 * create an object that contains the required key values pairs
 * from the s1.markupModifier or s1.blockInjector object params
 *
 * @returns obj
 */
const getBIParamsObj = () => {
  window.s1.blockInjector = window?.s1?.blockInjector || {};
  window.s1.markupModifier = window?.s1?.markupModifier || {};

  const userData = window.s1.markupModifier || window.s1.blockInjector;

  const currentDate = new Date();
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const biParamsObj = {
    city: userData?.city || 'your city',
    countryregion: userData?.countryRegionName || 'your region',
    countryregioncode: userData?.countryRegion || 'your region',
    country: 'your country',
    countrycode: userData?.country || 'your country',
    postalcode: userData?.postalCode || 'your zip code',
    day: weekDays[currentDate.getDay()] || '',
    month: monthNames[currentDate.getMonth()] || '',
    year: currentDate.getFullYear() || '',
  };

  return biParamsObj;
};

/**
 * get the placeholder keys from the post title string
 * @returns array
 */
const getPlaceHolderKeysArray = (postTitle) => {
  const placeHolderArray = [];

  // get all placeholders set within square bracets from a post's title
  const regexPattern = /\[(.*?)\]/gmi;
  let curMatch = regexPattern.exec(postTitle);
  while (curMatch) {
    placeHolderArray.push(curMatch[1]);
    curMatch = regexPattern.exec(postTitle);
  }
  return placeHolderArray;
};

/**
 * map string placeholders enclosed within curly braces in a Post's Title
 * with corresponding values from s1.blockInjector object
 * @param {object} biParamsObj
 * @param {array} placeHolderKeys
 * @returns
 */
const getmappedValues = (biParamsObj, placeHolderKeys) => {
  const mappedValues = [];

  placeHolderKeys.map((placeholderKey) => {
    const result = Object.entries(biParamsObj).find(
      ([key]) => key === placeholderKey.toLowerCase()
    );

    if (result && result[1]) {
      mappedValues.push(result[1]);
    } else {
      mappedValues.push(`[${placeholderKey}]`);
    }
    return true;
  });

  return mappedValues;
};

/**
 * perform a string replacement with corresponding key value pairs
 * @returns string
 */
const performDynamicOverride = (postTitle) => {
  const biObj = getBIParamsObj();
  const placeHolderArray = getPlaceHolderKeysArray(postTitle);

  if (!placeHolderArray) {
    return postTitle;
  }

  // map placeholder array with bi params Object
  const mappedValueArray = getmappedValues(biObj, placeHolderArray);
  const mapping = {};
  placeHolderArray.forEach((e, i) => { mapping[`[${e}]`] = mappedValueArray[i]; });
  return postTitle.replace(/\[\w+\]/gi, (match) => mapping[match]);
};

/**
 * Dynamic Overrides
 */
const dynamicOverrides = () => {
  // perform dynamic post title string override
  const postTitleEle = document.querySelector('.post-title');
  if (postTitleEle) {
    const updatedPostTitle = performDynamicOverride(postTitleEle.innerHTML);
    postTitleEle.innerHTML = updatedPostTitle;
    document.title = updatedPostTitle;
  }
};

export default dynamicOverrides;
